export var EventAction;
(function (EventAction) {
    EventAction["SendCommand"] = "sendCommand";
    EventAction["StartLoading"] = "startLoading";
    EventAction["StopLoading"] = "stopLoading";
    EventAction["HeightChange"] = "heightChange";
    EventAction["UploadFile"] = "uploadFile";
    EventAction["StateChangeSuccess"] = "stateChangeSuccess";
    EventAction["State"] = "state";
    EventAction["ShowModal"] = "showModal";
    EventAction["ShowStepperModal"] = "showStepperModal";
    EventAction["ShowChecklistModal"] = "showChecklistModal";
    EventAction["ShowOverlayAndBlockScroll"] = "showOverlayAndBlockScroll";
    EventAction["RemoveOverlayAndReleaseScroll"] = "removeOverlayAndReleaseScroll";
    EventAction["HideNavbar"] = "hideNavbar";
    EventAction["ShowNavbar"] = "showNavbar";
    EventAction["ChangeSubheaderTitle"] = "changeSubheaderTitle";
    EventAction["GetCurrentLanguage"] = "getCurrentLanguage";
    EventAction["Toast"] = "toast";
    EventAction["GetApplication"] = "getApplication";
    EventAction["HasPermissions"] = "hasPermissions";
    EventAction["GetPermissionsObject"] = "getPermissionsObject";
    EventAction["Segment"] = "segment";
    EventAction["UserContext"] = "getUserContext";
    EventAction["GetToken"] = "getToken";
    EventAction["GetAccount"] = "getAccount";
    EventAction["SendApplicationRequest"] = "sendApplicationRequest";
    EventAction["UnauthorizedAccess"] = "unauthorizedAccess";
    EventAction["AddTenantPrefixToUrl"] = "addTenantPrefixToUrl";
    EventAction["GetTenantUrl"] = "getTenantUrl";
    EventAction["GetTenantPlan"] = "getTenantPlan";
    EventAction["InviteUser"] = "inviteUser";
    EventAction["ChangeLocation"] = "changeLocation";
    EventAction["ChangePath"] = "changePath";
    EventAction["ShowUploadErrorToast"] = "showUploadErrorToast";
    EventAction["ShowAlert"] = "showAlert";
    EventAction["RedirectProcessor"] = "redirectProcessor";
    EventAction["RedirectToApplicationDetail"] = "redirectToApplicationDetail";
    EventAction["RedirectToApplicationList"] = "redirectToApplicationList";
    EventAction["RedirectToCreateAiAgent"] = "redirectToCreateAiAgent";
    EventAction["RedirectToSubscriptionNotificationPayment"] = "redirectToSubscriptionNotificationPayment";
    EventAction["RedirectToUserHistory"] = "redirectToUserHistory";
    EventAction["RedirectToJourney"] = "redirectToJourney";
    EventAction["CloseSidebar"] = "closeSidebar";
    EventAction["LaunchDarkly"] = "launchDarkly";
    EventAction["CreateApplication"] = "createApplication";
    EventAction["DeleteApplication"] = "deleteApplication";
    EventAction["ShowBlipChat"] = "showBlipChat";
})(EventAction || (EventAction = {}));
